import { render, staticRenderFns } from "./logicSelector.vue?vue&type=template&id=7ff07f87"
import script from "./logicSelector.vue?vue&type=script&lang=js"
export * from "./logicSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports